const b64DecodeUnicode = b64String =>
  decodeURIComponent(
    atob(b64String)
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

export default b64DecodeUnicode;
